import { useState } from 'react'
import { useIntl } from '@/intl'

export const useTexts = () => {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    title: translate({ id: 'sms4.settings.communication.notifications.almostThereSettings' }),

    description: translate({
      id: 'sms4.settings.communication.notifications.almostThereSettings.description',
    }),

    disableDescription: translate({
      id: 'sms4.settings.communication.notifications.almostThereSettings.toggle.disable',
    }),

    enableDescription: translate({
      id: 'sms4.settings.communication.notifications.almostThereSettings.toggle.enable',
    }),
  }))

  return api
}
